<button mat-icon-button [matMenuTriggerFor]="bookingItemDropdown" aria-label="Edit booking item state" i18n-aria-label>
  <mat-icon>more_horiz</mat-icon>
</button>
<mat-menu #bookingItemDropdown="matMenu">
  @if (isPublishable()) {
    <button mat-menu-item (click)="onPublish()" i18n>Publish</button>
  }
  @if (isArchivable()) {
    <button mat-menu-item (click)="onArchive()" i18n>Archive</button>
  }
  @if (isRetractable()) {
    <button mat-menu-item (click)="onRetract()" i18n>Move to draft</button>
  }
</mat-menu>
